//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { picFilter } from '@/assets/utils';
export default {
  name: 'SecondaryProcess',
  components: {},
  props: {
    data: {
      type: Array,
      required: true,
      default: null
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    data2: function data2() {
      return this.data.map(function (ele) {
        ele.materialImage = picFilter(ele.materialImage, {
          size: 'large'
        });
        return ele;
      });
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};